import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import Home from '@/views/Home.vue'


import wx from "@/utils/tools/wxTools.js";
Vue.use(wx);

Vue.use(Router)

let routes = []

const requireContext = require.context(
  './',
  true,
  /\.js$/
)
requireContext.keys().forEach(filename => {
  if (filename === './index.js') return
  const routerModule = requireContext(filename)
  routes = [...routes, ...(routerModule.default || routerModule)]
})

const router = new Router({
  mode: 'history',
  base: '/v/',
  routes: routes
})
router.addRoutes([
  {
    path: '/',
    name: 'home',
    component: Home
  }
])

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.meta.shareimg){
    document.getElementById('shareimg').content = to.meta.shareimg
  }
  if(to.meta.sharedsc){
    document.getElementById('sharedsc').content = to.meta.sharedsc
  }
  let ua = navigator.userAgent.toLowerCase();
  // 在微信浏览器和app环境下隐藏进度条
  if (ua.match(/MicroMessenger/i) != "micromessenger" && ua.indexOf('gkztc') == -1 ) {
    NProgress.start()
  }

  window.scrollTo(0,0)
  next()
})
router.afterEach((to, from) => {
  NProgress.done()
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.error('router error', error, targetPath)
  // alert('router error111', error)
  // 跳转回pendin中的路由路径
  // if (isChunkLoadFailed) {
  //   router.replace(targetPath);
  // }
  router.replace(targetPath);
});
export default router
